const googleTagManagerId = "UA-146505235-1";

module.exports = googleTagManagerId;
